import { atom } from 'jotai';

import {
  FacilityGroupFormState,
  FacilityGroupRecord,
} from '../types/facilityGroup';

const initialState: FacilityGroupFormState = {
  name: '',
  facilityIds: [],
};

export const $facilityGroupForm = atom<FacilityGroupFormState>(initialState);

export const $resetFacilityGroupForm = atom(null, (get, set) => {
  set($facilityGroupForm, initialState);
});

export const $updateFacilityGroupForm = atom(
  null,
  (get, set, update: Partial<FacilityGroupFormState>) => {
    const current = get($facilityGroupForm);
    set($facilityGroupForm, { ...current, ...update });
  },
);

export const $initializeFacilityGroupForm = atom(
  null,
  (get, set, facilityGroup?: FacilityGroupRecord) => {
    if (!facilityGroup) {
      set($facilityGroupForm, initialState);
      return;
    }

    set($facilityGroupForm, {
      id: facilityGroup.id,
      name: facilityGroup.name,
      facilityIds: facilityGroup.facilities.map((f) => f.id),
    });
  },
);
